export const MAX_COHORT_NAME_LENGTH = 60;
